import {observer} from "mobx-react-lite";
import {FlipCountdown} from "./flipCountDown";
import {roundTimeStore} from "../../store/roundTimeStore";
import Logo from './../../assets/images/betshop/logo.png';
import React from "react";
import {limitsTranslationKeys} from "../../enums/limitsTranslationKeys";
import {roundInfoStore} from "@pascal/pascal-core";

export const BetShopHeader  = observer(({t})=>{
    const { betShopTime } = roundTimeStore;
    const { ROUND_ID } = limitsTranslationKeys;
    const { roundId } = roundInfoStore;
    const timestamp = performance.now() + betShopTime * 1000;
    return (
        <>
            <div className='view-window-header'>
                <div className='header-container'>
                    <div className='logo-block'>
                        <img src={Logo}  alt='logo'/>
                    </div>
                    <div className='header-container-right'>
                        <p className='header-race-id'>
                            <span className='header-race-id-label'>{t(ROUND_ID)}</span>
                            <span className='header-race-id-value'>{roundId}</span>
                        </p>
                        <FlipCountdown endTimestamp={timestamp}/>
                    </div>
                </div>
            </div>
        </>
    )
})